import { render } from "./QuestionItem.vue?vue&type=template&id=45e7a5c6&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"

import "./QuestionItem.vue?vue&type=style&index=0&id=45e7a5c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e7a5c6"]])

export default __exports__